/**
 * Class representing an error result.
 */
export class AppError extends Error {
  constructor(public errorMsg: string, public error?: unknown) {
    super(errorMsg)
  }
}

/**
 * Function result that can be either a value or an error.
 * @param T Type of the value.
 */
export type FuncResult<T> = AppError | T;
